/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "9ad25b34734cd8eedd781393f7f750f59cefa17e";
